import OnboardingChecklistAlert from './OnboardingChecklistAlert';

export default OnboardingChecklistAlert;
